import React from 'react';
import { Typography } from '@heycater/design-system';
import { StarRate } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useBreakpointUp } from 'qualification/hooks/useBreakpoints';
import {
  formatRating,
  formatRatingCount,
} from 'shared/services/trustedShops/handleRatings';

interface Props {
  rating: number;
  ratingCount: number;
}

const RatingsSecondary: React.FC<Props> = ({ rating, ratingCount }) => {
  const isTablet = useBreakpointUp('md');
  const { t } = useTranslation('common');

  return (
    <Wrapper>
      <Stars>
        {Array(Math.ceil(rating))
          .fill(1)
          .map((_, index) => (
            <StarRate key={index} htmlColor="#F6D31B" />
          ))}
      </Stars>
      <Typography fontWeight={600} fontSize={14}>
        {formatRating(rating)}
      </Typography>
      <Typography fontSize={14}>{t('trustedShops.ratingText')}</Typography>
      {isTablet && (
        <Typography className="rating-count" fontSize={14}>
          {t('trustedShops.ratingCount', {
            amount: formatRatingCount(ratingCount),
          })}
        </Typography>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)}px;
  padding-top: ${({ theme }) => theme.spacing(3)}px;
  padding-bottom: ${({ theme }) => theme.spacing(2)}px;
  text-decoration: none;
  color: inherit;
`;

const Stars = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: { spacing } }) => spacing(0)}px;
  margin-top: -5px;
`;

export default RatingsSecondary;
